import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Tables } from "database.types";

export interface Props {
  card: Tables<"cards"> & { set: Tables<"sets">; game: Tables<"games"> };
}

export function CardDetailsModalCardInfo({ card }: Props) {
  const name = card.name;
  const set = card.set?.name;
  const number = card.number;
  const rarity = card.rarity;
  const game = card.game?.name;
  const tcgplayerId = card.tcgplayer_id;

  return (
    <Card>
      <CardHeader>
        <h3 className="text-lg font-semibold">Card Information</h3>
      </CardHeader>
      <CardContent className="space-y-2">
        <div className="flex justify-between gap-2">
          <span className="text-muted-foreground">Name:</span>
          <span className="font-medium text-right">{name}</span>
        </div>
        {card.set?.name && (
          <div className="flex justify-between gap-2">
            <span className="text-muted-foreground">Set:</span>
            <span className="font-medium text-right">{set}</span>
          </div>
        )}
        {card.number && (
          <div className="flex justify-between gap-2">
            <span className="text-muted-foreground">Number:</span>
            <span className="font-medium text-right">#{number}</span>
          </div>
        )}
        {card.rarity && (
          <div className="flex justify-between gap-2">
            <span className="text-muted-foreground">Rarity:</span>
            <span className="font-medium text-right">{rarity}</span>
          </div>
        )}
        {card.game?.name && (
          <div className="flex justify-between gap-2">
            <span className="text-muted-foreground">Game:</span>
            <span className="font-medium text-right">{game}</span>
          </div>
        )}
        {card.tcgplayer_id && (
          <div className="flex justify-between gap-2">
            <span className="text-muted-foreground">TCGplayer ID:</span>
            <span className="font-medium text-right">{tcgplayerId}</span>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
